import Vue from "vue";
import VueRouter from "vue-router";
import VueCookies from 'vue-cookies';
import VueJwtDecode from 'vue-jwt-decode'

Vue.use(VueRouter);

function checkSecretKey(to, from, next) {
    const encodedString = localStorage.getItem("sign-in");

    console.log(encodedString + "here");

    if (!encodedString) {
        next("/sign-in");
        return;
    }

    const decodedString = atob(encodedString);
    if (decodedString && decodedString.includes("your_secret_key")) {
        next();
    } else {
        next("/sign-in");
    }
}

let routes = [
    {
        path: "/404",
        name: "404",
        layout: "public",
        meta: {
            title: "404 - Page Not Found",
            layout: "public",
        },
        component: () => import("../views/404.vue"),
    },
    {
        path: "/",
        name: "Home",
        redirect: "/loads/loads-list",
    },
    {
        path: "/sign-in",
        name: "Sign In",
        redirect: "/login",
    },
    {
        path: "/login",
        name: "Login",
        layout: "public",
        meta: {
            title: "Login",
            public: true,
            layout: "public",
        },
        component: () => import("../views/Authentication/Sign-in/SignIn.vue"),
    },

    {
        path: "/loads/edit/:id",
        name: "Edit Load",
        layout: "dashboard",
        meta: {
            title: "Edit Load",
            sidebarMap: ["loads", "edit-load"],
            breadcrumbs: ["Loads", "Edit Load"],
        },
        component: () => import("../views/Loads/EditLoad.vue"),
    },
    {
        path: "/loads/create",
        name: "Create Load",
        layout: "dashboard",
        meta: {
            title: "Create Load",
            sidebarMap: ["loads", "load"],
            breadcrumbs: ["Loads", "Create Load"],
        },
        component: () => import("../views/Loads/EditLoad.vue"),
    },
    {
        path: "/loads/loads-list",
        name: "Loads List",
        layout: "dashboard",
        meta: {
            title: "Loads List",
            sidebarMap: ["loads", "loads-list"],
            breadcrumbs: ["Loads", "Loads List"],
        },
        component: () => import("../views/Loads/LoadsList.vue"),
    },
    // Companies routes
    {
        path: "/companies/edit/:id",
        name: "Edit Company",
        layout: "dashboard",
        meta: {
            title: "Edit Company",
            sidebarMap: ["companies", "edit-company"],
            breadcrumbs: ["Companies", "Edit Company"],
        },
        component: () => import("../views/Companies/EditCompany.vue"),
    },
    {
        path: "/companies/create",
        name: "Create Company",
        layout: "dashboard",
        meta: {
            title: "Create Company",
            sidebarMap: ["companies", "company"],
            breadcrumbs: ["Companies", "Create Company"],
        },
        component: () => import("../views/Companies/EditCompany.vue"),
    },
    {
        path: "/companies/companies-list",
        name: "Companies List",
        layout: "dashboard",
        meta: {
            title: "Companies List",
            sidebarMap: ["companies", "companies-list"],
            breadcrumbs: ["Companies", "Companies List"],
        },
        component: () => import("../views/Companies/CompaniesList.vue"),
    },
    // Users routes
    {
        path: "/users/edit/:id",
        name: "Edit User",
        layout: "dashboard",
        meta: {
            title: "Edit User",
            sidebarMap: ["users", "edit-user"],
            breadcrumbs: ["Users", "Edit User"],
        },
        component: () => import("../views/Users/EditUser.vue"),
    },
    {
        path: "/users/create",
        name: "Create User",
        layout: "dashboard",
        meta: {
            title: "Create User",
            sidebarMap: ["users", "user"],
            breadcrumbs: ["Users", "Create User"],
        },
        component: () => import("../views/Users/EditUser.vue"),
    },
    {
        path: "/users/users-list",
        name: "Users List",
        layout: "dashboard",
        meta: {
            title: "Users List",
            sidebarMap: ["users", "users-list"],
            breadcrumbs: ["Users", "Users List"],
        },
        component: () => import("../views/Users/UsersList.vue"),
    },
    // Admins routes
    {
        path: "/admins/admins-list",
        name: "Admins List",
        layout: "dashboard",
        meta: {
            title: "Admins List",
            sidebarMap: ["admins", "admins-list"],
            breadcrumbs: ["Admins", "Admins List"],
        },
        component: () => import("../views/Admins/AdminsList.vue"),
    },
    {
        path: "/authentication/sign-up/basic",
        name: "Basic Sign Up",
        layout: "public",
        meta: {
            layoutClass: "layout-sign-up",
            title: "Basic Sign Up",
            sidebarMap: ["authentication", "sign-up", "basic"],
            breadcrumbs: ["Authentication", "Sign Up", "Basic"],
            layout: "public",
        },
        component: () => import("../views/Authentication/Sign-Up/Basic.vue"),
    },
    {
        path: "/authentication/sign-up/cover",
        name: "Cover Sign Up",
        layout: "public",
        meta: {
            layoutClass: "layout-sign-up-cover",
            title: "Cover Sign Up",
            sidebarMap: ["authentication", "sign-up", "cover"],
            breadcrumbs: ["Authentication", "Sign Up", "Cover"],
            layout: "public",
        },
        component: () => import("../views/Authentication/Sign-Up/Cover.vue"),
    },
    {
        path: "/authentication/sign-up/illustration",
        name: "Illustration Sign Up",
        layout: "public",
        meta: {
            layoutClass: "layout-sign-up-illustration",
            title: "Illustration Sign Up",
            sidebarMap: ["authentication", "sign-up", "illustration"],
            breadcrumbs: ["Authentication", "Sign Up", "Illustration"],
            nofooter: true,
            layout: "public",
        },
        component: () => import("../views/Authentication/Sign-Up/Illustration.vue"),
    },
    {
        path: "/register/user",
        name: "User Registration",
        layout: "public",
        meta: {
            title: "User Registration",
            public: true,
            layout: "public",
        },
        component: () => import("../views/Authentication/UserRegister.vue"),
    },
    {
        path: "/register/company",
        name: "Company Registration",
        layout: "public",
        meta: {
            title: "Company Registration",
            public: true,
            layout: "public",
        },
        component: () => import("../views/Authentication/CompanyRegister.vue"),
    },
    {
        path: "/profile",
        name: "Profile",
        layout: "dashboard",
        meta: {
            title: "My Profile",
            sidebarMap: ["profile"],
            breadcrumbs: ["Profile"],
        },
        component: () => import("../views/Profile.vue"),
    },
    {
        path: "/layout",
        name: "Layout",
        layout: "dashboard",
        component: () => import("../views/Layout.vue"),
    },
    {
        // will match everything - MUST be last
        path: "*",
        redirect: "/404",
    },
];

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
    route.meta = route.meta || {};
    route.meta.layout = route.layout || parentLayout;

    if (route.children) {
        route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
    }
    return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: "smooth",
            };
        }
        return {
            x: 0,
            y: 0,
            behavior: "smooth",
        };
    },
});
// Helper function to check authentication and role
function isAuthenticated() {
    const accessToken = VueCookies.get("access_token");
    if (!accessToken) return false;

    try {
        const decodedToken = VueJwtDecode.decode(accessToken);
        return decodedToken;
    } catch (error) {
        console.error("Invalid token", error);
        return false;
    }
}

// Helper function to check if user is admin
function isAdminUser() {
    return localStorage.getItem('userType') === 'admin';
}

router.beforeEach((to, from, next) => {
    const decodedToken = isAuthenticated();
    const isPublic = to.meta && to.meta.public;
    
    console.log('Route guard - to:', to.path);
    console.log('Route guard - isPublic:', isPublic);
    console.log('Route guard - decodedToken:', decodedToken);
    console.log('Route guard - meta:', to.meta);
    
    if (!decodedToken && !isPublic) {
        // Not authenticated, and route is not public: redirect to login
        console.log('Redirecting to login - not authenticated and not public');
        next({ name: "Login" });
        return;
    }

    if (decodedToken && to.name === "Login") {
        // Already authenticated, do not allow going back to login
        next({ name: "Home" });
        return;
    }

    // Check if route requires admin access
    const isAdminRoute = to.path.includes('/companies') || to.path.includes('/users');
    if (isAdminRoute && !isAdminUser()) {
        // Non-admin user trying to access admin route: redirect to 404
        next({ name: "404" });
        return;
    }

    console.log('Route guard - proceeding to:', to.path);
    next();
});

export default router;
